import { computed, ref } from "vue";

import { useTickersStore } from "@/stores/Tickers";
import type { ContentfulItem, HasSectorContext, SearchableTicker } from "@tmi/types/entities";

/*********************************************************************/
//                       NON-REACTIVE CONSTANTS                      //
/*********************************************************************/
import { consoleLoggerFactory, getDefaultLoggerOptions, ILogger, LogLevels } from "@/types/console-logger";
const logger: ILogger = consoleLoggerFactory.create( getDefaultLoggerOptions( LogLevels.ERROR ) );

/*********************************************************************/
//                 GLOBALLY SHARED REACTIVE VARIABLES                //
/*********************************************************************/

// A list of category ids for content that is associated with the categories in the collection (inclusive)
const includeTickerFilter = ref< SearchableTicker[] >( [] );

export function useTickerFilter() {
    const tickersStore = useTickersStore();

    const tickerIdFilter = computed< string[] >( () => includeTickerFilter.value.map( ( filter: SearchableTicker ) => filter.id ) );

    function filterOutItemsThatDoNotContainSelectedTickers( contentItems: HasSectorContext[] ): ContentfulItem[] {
        if ( tickerIdFilter.value?.length === 0 ) {
            return contentItems;
        }

        logger.debug( '[ ticker-filter ] tickerIdFilter : ', tickerIdFilter.value );
        const contentWithTicker: HasSectorContext[] = contentItems.filter( ( content: HasSectorContext ): boolean => {
            const contentTickerIds: string[] = content.tickers.map( ( ticker: SearchableTicker ) => ticker.id );

            let found: boolean = false;
            if ( contentTickerIds.length > 0 ) {
                logger.debug( '[ ticker-filter ] contentTickerIds : ', contentTickerIds );

                found = contentTickerIds.some( ( contentTickerId: string ) => tickerIdFilter.value.includes( contentTickerId ) );
                logger.debug( '[ ticker-filter ] found match : ', found );
            }

            return found;
        } );

        logger.debug( '[ ticker-filter ] filtered content items: ', contentWithTicker );
        return contentWithTicker;
    }

    return {
        filterOutItemsThatDoNotContainSelectedTickers,
        includeTickerFilter
    };
}
